// eslint-disable-next-line no-unused-vars
import { service } from '@/utils/request/service';

// 数据备份查询
export function getBackupList(query) {
  return service({
    url: 'SystemSecurity/DbBackup/GetGridJson',
    method: 'get',
    params: query,
  });
}
export function downloadBackup(formData) {
  return service({
    url: 'SystemSecurity/DbBackup/DownloadBackup',
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'POST',
    data: formData,
  });
}
// 数据备份中的刷新
export function delBackup(formData) {
  return service({
    url: 'SystemSecurity/DbBackup/DeleteForm',
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
}
// 访问控制的新建策略
export function getStrategyList(params) {
  return service({
    url: 'SystemSecurity/FilterIP/GetGridJson',
    method: 'GET',
    params,
  });
}
export function addStrategy(formData, params = {}) {
  return service({
    url: 'SystemSecurity/FilterIP/SubmitForm',
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    params,
  });
}
// 删除
export function delStrategy(formData) {
  return service({
    url: 'SystemSecurity/FilterIP/DeleteForm',
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    params: formData,
  });
}

// 系统日志的查询
export function getSystemLogs(params) {
  return service({
    url: 'SystemSecurity/Log/GetGridJson',
    method: 'GET',
    params,
  });
}
// 系统日志的清空日志
export function clearSystemLog(formData = { keepTime: 3 }) {
  return service({
    url: 'SystemSecurity/Log/SubmitRemoveLogn',
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
}
